<template>
  <div style="margin: 0 0 auto">
    <div class="ResearchMainContainer">
      <div class="ResearchHeroContainer">
        <h1 class="hero-title" style="grid-area: title">
          Guocheng SHAO 邵国诚
        </h1>
        <div class="HeroContent" style="grid-area: content">
          <p class="hero-info">
            I'm a master's student in CSIT at Hong Kong University of Science
            and Technology (<a href="https://hkust.edu.hk/" target="_blank"
              >HKUST</a
            >). I obtained my bachelor's degree in School of Software
            Engineering at Tongji University (<a
              href="https://www.tongji.edu.cn/"
              target="_blank"
              >TJU</a
            >). My research interests include computer vision and computer
            graphics, especially in generative models, 3D reconstruction and
            stylized rendering.
          </p>
          <div class="hero-socialmedia">
            <a href="mailto:gshao@connect.ust.hk">Email</a> /
            <a
              href="https://DukeofCambridge.github.io/#/homepage-guocheng"
              target="_blank"
              >Homepage</a
            >
            /
            <a href="https://github.com/DukeofCambridge" target="_blank"
              >Github</a
            >
          </div>
        </div>
        <div class="HeroImage" style="grid-area: img">
          <img src="../assets/selfie.jpg" draggable="false" />
        </div>
      </div>
      <div class="ResearchCaption"><h2>Education</h2></div>
      <div class="ResearchEducationContainer">
        <div class="School">
          <div class="school-logo">
            <img src="../assets/HKUST.png" draggable="false" alt="HKUST logo" />
          </div>
          <div class="school-info">
            <h3>
              <strong>Hong Kong University of Science and Technology</strong>
            </h3>
            <div class="school-time">
              <div class="left">M.S. in Information Technology</div>
              <div class="right">Sep. 2023 - Aug. 2024</div>
            </div>
            <p class="school-gpa">GPA: 4.06/4.30</p>
          </div>
        </div>
        <div class="School">
          <div class="school-logo">
            <img
              src="@/assets/tongji.png"
              draggable="false"
              alt="Tongji logo"
            />
          </div>
          <div class="school-info">
            <h3><strong>Tongji University</strong></h3>
            <div class="school-time">
              <div class="left">B.Eng in Software Engineering</div>
              <div class="right">Sep. 2019 - Jul. 2023</div>
            </div>
            <p class="school-gpa">Overall GPA: 88.35/100.00</p>
            <p class="school-gpa">Specialized Course GPA: 91.70/100.00</p>
          </div>
        </div>
      </div>
      <div class="ResearchCaption"><h2>Publications</h2></div>
      <div class="ResearchPublicationContainer">
        <div class="Publication">
          <div class="publication-arch-fig">
            <img
              src="../assets/pipeline_compare.png"
              draggable="false"
              alt="Rendering Pipeline Comparison"
            />
          </div>
          <div class="publication-info">
            <h3>
              <strong>Advances in 3D Neural Stylization: A Survey</strong>
            </h3>
            <p>
              Yingshu Chen*, <strong>Guocheng Shao</strong>, Ka Chun Shum,
              Binh-Son Hua, Sai-Kit Yeung
            </p>
            <p>
              Submitted to International Journal of Computer Vision (IJCV) 2024,
              Under Review
            </p>
            <div class="publication-links">
              <a href="https://arxiv.org/abs/2311.18328" target="_blank"
                >Paper</a
              >
              /
              <a
                href="https://github.com/chenyingshu/advances_3d_neural_stylization"
                target="_blank"
                >Code</a
              >
            </div>
          </div>
        </div>

        <div class="Publication">
          <div class="publication-arch-fig">
            <img src="../assets/underwater.png" draggable="false" />
          </div>
          <div class="publication-info">
            <h3>
              <strong
                >UW-Real: Enhancing Synthetic Underwater Scenes Towards
                Realism</strong
              >
            </h3>
            <p>TBD</p>
            <p>Intended to WACV 2025</p>
            <div class="publication-links">
              Tag:
              <a disabled>3DGS</a> / <a disabled>Style Transfer</a> /
              <a disabled>Diffusion Model</a>
            </div>
          </div>
        </div>
      </div>
      <div class="ResearchCaption"><h2>Intern</h2></div>
      <div class="ResearchInternContainer">
        <div class="Intern">
          <div class="intern-header">
            <div class="intern-logo">
              <img
                id="lab-logo"
                src="@/assets/HKUST_VIL.png"
                draggable="false"
              />
            </div>
          </div>
          <div class="intern-info">
            <ul>
              <li>
                HKUST
                <a href="https://cqf.io/index.html" target="_blank">
                  Visual Intelligence Lab</a
                >
                / Full-time Research Assistant
              </li>
              <li>
                Video generation algorithms testing and deployment. / Model
                finetuning.
              </li>
            </ul>
          </div>
        </div>
        <div class="Intern">
          <div class="intern-header">
            <div class="intern-logo">
              <img
                id="tencent-logo"
                src="https://images.ctfassets.net/odsfb7g0v9wp/35naAl7ABGazXGYBJyTQ3R/4f126e19be09ae2e6897a48505f9dcac/tencent_logo.png"
                draggable="false"
              />
            </div>
          </div>
          <div class="intern-info">
            <ul>
              <li>
                Interactive Entertainment Group (IEG) / Unreal Engine Plugin
                Development
              </li>
              <li>
                Explore integrating neural networks in game engine rendering
                pipeline. Develop plugin for real-time style transfer with
                neural network inference.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="ResearchCaption"><h2>Awards &amp; Honors</h2></div>
      <div class="ResearchAwardContainer">
        <ol>
          <li>
            <div>
              School of Engineering Excellent Student Scholarship, HKUST<span
                >08/2024</span
              >
            </div>
          </li>
          <li>
            <div>
              Excellent Student Scholarship (Fall 2023), HKUST<span
                >03/2024</span
              >
            </div>
          </li>
          <li>
            <div>
              Taiyuan Scholarship for Undergraduate Student, Tongji
              University<span>11/2022</span>
            </div>
          </li>
          <li>
            <div>
              Meritorious Winner in Mathematical Contest in Modeling, COMAP,
              US<span>05/2022</span>
            </div>
          </li>
          <li>
            <div>
              Outstanding Undergraduate Student Scholarship, Tongji
              University<span>11/2021</span>
            </div>
          </li>
        </ol>
      </div>
      <div class="ResearchCaption"><h2>Others</h2></div>
      <div class="ResearchOthersContainer">
        <div class="OtherContainer">
          <h3 class="other-title">Student Work</h3>
          <ul>
            <li>
              Outstanding member of Interview and Writing Department, Tongji
              Univ. Student Union.
            </li>
          </ul>
        </div>
        <div class="OtherContainer">
          <h3 class="other-title">Hobbies</h3>
          <ul>
            <li>🎦 Movie/Gaming/Music</li>
            <li>🏸 Badminton</li>
            <li>🎞️️ Video Editing</li>
            <li>💪 Fitness</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
* {
  border: 0;
  box-sizing: border-box;
  margin: 0 0 auto;
  --page-width: 76%;
  --page-margin-top: 5%;
  --container-width: 94%;
  --list-left-margin: 50px;
}

.ResearchMainContainer {
  display: flex;
  flex-direction: column;
  width: var(--page-width);
  margin: var(--page-margin-top) calc(50% - var(--page-width) / 2);
  word-wrap: break-word;
}

.ResearchHeroContainer {
  width: 100%;
  display: grid;
  grid-template-areas:
    "title title img"
    "content content img"
    "content content img";
  margin-bottom: 40px;
}

.ResearchHeroContainer .hero-title {
  text-align: center;
  font-size: 2.5em;
  background: linear-gradient(104deg, #050a27, #4a54bc 80%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ResearchHeroContainer .HeroContent {
  align-self: flex-start;
}

.ResearchHeroContainer .HeroContent .hero-info {
  font-size: 1.1em;
}

.ResearchHeroContainer .HeroContent .hero-socialmedia {
  text-align: center;
  margin: 15px auto 0;
}

.ResearchHeroContainer .HeroContent .hero-socialmedia a {
  margin: 0 5px;
}

.ResearchHeroContainer .HeroImage {
  justify-self: center;
  width: auto;
  height: 250px;
  -o-object-fit: contain;
  object-fit: contain;
  margin-left: 20px;
}

.ResearchHeroContainer .HeroImage img {
  height: 100%;
  width: auto;
  -o-object-fit: contain;
  object-fit: contain;
  display: block;
  border-radius: 4px;
}

.ResearchCaption {
  margin: 20px 0 5px;
}

.ResearchCaption h2 {
  font-size: 1.5em;
  font-weight: 800;
  position: relative;
  background: linear-gradient(104deg, #050a27, #4a54bc 15%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ResearchCaption h2:before {
  content: "\222E";
  position: absolute;
  top: 1px;
  left: -30px;
  background: linear-gradient(104deg, #050a27, #4a54bc);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ResearchEducationContainer {
  width: var(--container-width);
  margin: 0 calc(50% - var(--container-width) / 2);
  display: flex;
  flex-direction: column;
}

.ResearchEducationContainer .School {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  margin: 15px 0;
}

.ResearchEducationContainer .school-logo {
  padding: 10px;
}

.ResearchEducationContainer .school-logo img {
  width: 75px;
  height: 100%;
  margin: 0 15px;
  -o-object-fit: contain;
  object-fit: contain;
}

.ResearchEducationContainer .school-time {
  display: flex;
  justify-content: space-between;
}

.ResearchEducationContainer .school-time .left {
  text-align: left;
}

.ResearchEducationContainer .school-time .right {
  text-align: right;
  font-size: 0.8em;
}

.ResearchEducationContainer .school-time:nth-child(4) {
  margin-top: 15px;
}

.ResearchEducationContainer .school-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: auto 0;
}

.ResearchPublicationContainer {
  width: var(--container-width);
  margin: 0 0 0 calc(50% - var(--container-width) / 2);
  display: flex;
  flex-direction: column;
}

.ResearchPublicationContainer .Publication {
  display: flex;
  flex-direction: row;
  align-items: normal;
  width: 100%;
  margin: 15px 0;
}

.Publication .publication-arch-fig {
  height: 100%;
  padding: 10px;
  margin: auto 15px;
}

.Publication .publication-arch-fig img {
  width: 250px;
  height: 100%;
  object-fit: contain;
}

.Publication .publication-info {
  margin: auto 0;
}

.Publication .publication-info .publication-links a:first-child {
  margin-left: 0;
}

a {
  margin: 0 5px;
  font-size: 0.8em;
  text-decoration: none;
  color: #4a54bc;
  border: 1px solid #4a54bc;
  padding: 3px 5px;
  border-radius: 4px;
  transition: 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
}

a:hover {
  background-color: #4a54bc;
  color: white;
}

.ResearchInternContainer {
  width: var(--container-width);
  margin: 0 calc(50% - var(--container-width) / 2);
  display: flex;
  flex-direction: column;
}

.ResearchInternContainer .Intern {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 15px 0;
}

.Intern .intern-header,
.Intern .intern-logo {
  min-height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.Intern .intern-header {
  width: 100%;
  justify-content: space-between;
}

#lab-logo,
#tencent-logo {
  max-width: 175px;
}

.Intern .intern-logo img {
  max-width: 150px;
  max-height: 90px;
  object-fit: contain;
}

.Intern .intern-logo img:nth-child(2) {
  margin-left: 15px;
}

.ResearchAwardContainer {
  width: var(--container-width);
  margin: 0 calc(50% - var(--container-width) / 2);
}

.ResearchAwardContainer ol {
  width: 95%;
  margin-left: 5%;
  line-height: 1.5;
  padding: 0;
}

.ResearchAwardContainer li {
  width: 100%;
  display: list-item;
}

.ResearchAwardContainer li div {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.ResearchAwardContainer li span {
  font-size: 0.8em;
  align-self: center;
}

.ResearchOthersContainer {
  width: var(--container-width);
  margin: 0 calc(50% - var(--container-width) / 2);
}

.ResearchOthersContainer .OtherContainer {
  margin: 15px 0;
}

.ResearchOthersContainer .OtherContainer:first-child {
  margin: 0;
}

.OtherContainer ul {
  margin-left: var(--list-left-margin);
  padding: 0;
}

.FooterGroup {
  margin: 50px auto 15px;
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.FooterGroup .Text {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif;
  font-size: 15px;
  letter-spacing: 1.5px;
  color: rgba(0, 0, 0, 0.4);
  font-weight: 600;
  text-align: center;
  margin: 1px auto;
}

@media only screen and (max-width: 750px) {
  * {
    --page-width: 92%;
    --page-margin-top: 10%;
    --container-width: 100%;
    --list-left-margin: 35px;
  }

  .ResearchHeroContainer {
    grid-template-areas:
      "title title title title img"
      "content content content content content";
  }

  .ResearchHeroContainer .hero-title {
    font-size: 2.2em;
    align-self: center;
  }

  .ResearchHeroContainer .HeroImage {
    align-self: center;
    height: 120px;
    margin-left: 0;
    margin-bottom: 5px;
  }

  .ResearchCaption h2:before {
    top: 8px;
    left: -12px;
    font-size: 0.5em;
  }

  .ResearchEducationContainer .School {
    margin: 10px 0;
  }

  .ResearchEducationContainer .school-logo {
    padding: 5px;
  }

  .ResearchEducationContainer .school-logo img {
    width: 65px;
    margin: 5px 12.5px 0 0;
  }

  .ResearchEducationContainer .school-time {
    display: flex;
    flex-direction: column;
  }

  .ResearchEducationContainer .school-time .right {
    text-align: left;
    font-size: 1em;
  }

  .ResearchPublicationContainer .Publication {
    flex-direction: column;
    text-align: center;
  }

  .Publication .publication-info {
    font-size: 0.75em;
  }

  .Publication .publication-info p {
    max-width: 84%;
    margin: 5px 8%;
  }

  .ResearchInternContainer .Intern {
    margin: 10px 0;
  }

  .Intern .intern-info {
    font-size: 0.8em;
  }

  #alibaba-logo #tencent-logo {
    max-width: 100px;
  }

  .ResearchAwardContainer ol {
    font-size: 0.75em;
  }

  .ResearchAwardContainer ol li span {
    min-width: 15%;
    font-size: 0.5em;
  }

  .ResearchOthersContainer .OtherContainer {
    font-size: 0.8em;
  }

  .FooterGroup .Text {
    font-size: 8px;
    font-weight: 400;
    letter-spacing: 0.5px;
  }
}
</style>
